/** Deduplicate cacheable Sportsnew prefetches without cancelling their owner. */

export function beginSportsnewKeyedPrefetch({ registry, key, run }) {
  if (!(registry instanceof Map)) throw new TypeError('registry must be a Map');
  if (typeof key !== 'string' || key.length === 0) throw new TypeError('key is required');
  if (typeof run !== 'function') throw new TypeError('run must be a function');
  const existing = registry.get(key);
  if (existing) return { ...existing, started: false };
  const owner = Object.freeze({});
  const entry = { owner, promise: null };
  registry.set(key, entry);
  entry.promise = Promise.resolve().then(run).finally(() => {
    if (registry.get(key)?.owner === owner) registry.delete(key);
  });
  return { ...entry, started: true };
}

export function sportsnewPrefetchPromisesForKeys({ registry, keys }) {
  if (!(registry instanceof Map)) throw new TypeError('registry must be a Map');
  const uniqueKeys = new Set(Array.isArray(keys) ? keys : [...(keys ?? [])]);
  return [...uniqueKeys]
    .map((key) => registry.get(key)?.promise)
    .filter(Boolean);
}

export function scheduleSportsnewPrefetchSettlements({
  promises,
  onSettled,
  isCancelled = () => false,
}) {
  if (typeof onSettled !== 'function') throw new TypeError('onSettled must be a function');
  const uniquePromises = [...new Set((promises ?? []).filter(Boolean))];
  uniquePromises.forEach((promise) => {
    // Settle each pre-event owner independently. A slow request for an old tab
    // must not delay the current tab's trailing membership refresh.
    void Promise.allSettled([promise]).then(() => {
      if (!isCancelled()) onSettled();
    });
  });
  return uniquePromises.length;
}
